import { useTranslate } from "@similarweb/i18n-provider";

import { MetricWidgetChart } from "../../common/widget/donut-metric/MetricWidgetChart";
import { MetricWidgetContainer } from "../../common/widget/donut-metric/MetricWidgetContainer";
import { MetricWidgetModal } from "../../common/widget/donut-metric/MetricWidgetModal";
import { MetricWidgetProvider } from "../../common/widget/donut-metric/MetricWidgetProvider";

import { ContentActivityLegend } from "./ContentActivityLegend";
import { ContentActivityTable } from "./ContentActivityTable";
import { useContentActivityQuery } from "./useContentActivityQuery";

export const ContentActivity = () => {
    const { translate } = useTranslate();
    const { data: chartData, isLoading, isError } = useContentActivityQuery();

    return (
        <MetricWidgetProvider
            chartData={chartData}
            isLoading={isLoading}
            isError={isError}
        >
            <MetricWidgetContainer
                title={translate("activation.alerts.website-content.metrics.title")}
                automationId="content-activity-metrics-widget"
                seeAllAutomationId="see-all-content-activity-button"
            >
                <MetricWidgetChart>
                    <ContentActivityLegend />
                </MetricWidgetChart>
            </MetricWidgetContainer>
            <MetricWidgetModal
                title={translate("activation.alerts.website-content.metrics.title")}
                automationId="all-content-activity-modal"
            >
                <ContentActivityTable />
            </MetricWidgetModal>
        </MetricWidgetProvider>
    );
};
